<template>
  <div id="map-pin">
    <el-row class="row_head_map">
      <el-col class="text-center relative">
        <h2 class="text-title--large">{{ $t('drawer.map.header') }}</h2>
        <a class="btn-search" @click="$emit('back_page')"><i class="el-icon-search"></i></a>
      </el-col>
    </el-row>
    <div id="map-area">
      <!-- <GmapMap
        v-if="currentLocation"
        :center="currentLocation" :zoom="17" :options="{disableDefaultUI:true}"
      >
        <GmapMarker
          :position="currentLocation"
          :draggable="true"
          @dragend="updateCoordinates"
          :icon="{ url: require('@/assets/icons/pin2.png') }"
        />
      </GmapMap> -->
      <Gmap 
        :position="currentLocation"
        @change="updateCoordinates"
        :marker-icon="require('@/assets/icons/pin2.png')"
        width="100%"
        height="100%"
      />
    </div>
    <div class="confirm-address">
      <el-row class="map-row-list list">
          <el-col :span="3" class="text-center">
            <img src="@/assets/icons/noun_location.png" width="18">
          </el-col>
        <el-col :span="21" class="text-body">
          <el-row>
            <el-col :span="24">{{map_item.title}}</el-col>
            <el-col :span="24" class="color-info--text">{{map_item.text}}</el-col>
          </el-row>
        </el-col>
      </el-row>
			<fullButton :handleClick="()=>{sendLocation()}" :btn_text="$t('drawer.map.confirmaddress')" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import fullButton from '@/components/element/fullButton'
import Gmap from '@/components/element/Gmap'

export default {
  props: {
    // map_item: {
    //   default: () => {}
    // },
  },
  components: {
    fullButton,
    Gmap
  },
  data() {
    return {
      currentLocation : null,
      searchAddressInput: '',
      center: null,
      coordinates: {},
      map_item: {},
      is_drag: false
    };
  },
  methods: {
    geolocation : function() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    },
    updateCoordinates(location) {
      this.is_drag = true
      this.coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
        address: ''
      }
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({
        // 'region':'th',
        'location': {
          lat: this.coordinates.lat,
          lng: this.coordinates.lng
        }
      },this.getPlaceAddress)
    },
    getPlaceAddress(results, status) {
      if (status === 'OK') {
        if (results[0]) {
          this.map_item.title = results[0].address_components[0].long_name
          this.map_item.text = results[0].formatted_address
          if (results[0].formatted_address) {
            this.coordinates.address = results[0].formatted_address
          }
          this.$forceUpdate()
        } else {
          window.alert('No results found')
        }
      }
    },
    sendLocation() {
      if (this.is_drag) {
        this.coordinates.address = this.map_item.text

        // recheck duplicate location
        this.recheckDupLocation()

        localStorage.setItem('fsloc',JSON.stringify(this.coordinates))
        let location = JSON.parse(localStorage.getItem('fsloc'))
        this.$store.dispatch('calculateDistanceOSRM', {
              origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
              origin_address: this.BranchDetail.address,
              destination_address: location.address,
              destination_coordinates: [location.lat, location.lng]
            }).then((distance) => {
              let noDistance = true
              if(distance !== null && distance !== undefined){
                  noDistance = false
                  this.$store.dispatch('getDistanceInfo', {
                    distance: distance,
                    total: this.TotalCartPrice,
                    location: { lat: location.lat, lng: location.lng, address: location.address },
                    restaurant: this.BranchDetail.restaurantId,
                    branch: this.BranchDetail.id
                  }).then( (response) => {
                    this.$emit('distance_info', response)
                  })
              }
              if(noDistance){
                this.$store.dispatch('calculateDistanceMatrix', {
                  origin_coordinates: [this.BranchDetail.latitude, this.BranchDetail.longitude],
                  origin_address: this.BranchDetail.address,
                  destination_address: location.address,
                  destination_coordinates: [location.lat, location.lng]
                }).then((distance) => {
                  this.$store.dispatch('getDistanceInfo', {
                    distance: distance,
                    total: this.TotalCartPrice,
                    location: { lat: location.lat, lng: location.lng, address: location.address },
                    restaurant: this.BranchDetail.restaurantId,
                    branch: this.BranchDetail.id
                  }).then( (response) => {
                    this.$emit('distance_info', response)
                  })
                })
              }
            })
      } else {
        this.$emit('close_map')
      }
    },
    recheckDupLocation () {
      let loc = JSON.parse(localStorage.getItem('fsloc'))
      if (loc !== null && typeof loc !== 'undefined') {
        if (loc.lat == this.coordinates.lat && loc.lng == this.coordinates.lng) {
          this.coordinates.new = 0
          this.$store.dispatch('setChangeLocation', {
            status: 'old',
            branch: this.BranchDetail,
            location: this.coordinates
          })
        } else {
          this.coordinates.new = 1
          this.$store.dispatch('setChangeLocation', {
            status: 'new',
            branch: this.BranchDetail,
            location: this.coordinates
          })
        }
      } else {
        this.coordinates.new = 0
        this.$store.dispatch('setChangeLocation', {
          status: 'first',
          branch: this.BranchDetail,
          location: this.coordinates
        })
      }
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    TotalCartPrice () {
      return this.$store.getters.TotalCartPrice
    }
  },
  mounted(){
    let location = JSON.parse(localStorage.getItem('fsloc'))
    if (location !== null && typeof location !== 'undefined') {
      this.currentLocation = { lat:location.lat, lng:location.lng}
      this.map_item.title = location.address.split(',')[0]
      this.map_item.text = location.address
    } else {
      this.geolocation()
      // this.currentLocation = { lat: 13.764916717992543, lng: 100.5383007797655 }
    }
  },
};

</script>




// WEBPACK FOOTER //
// src/components/map/MapPin.vue